import resize from '../helpers/resize'

class Menu {
  constructor(el) {
    this.menu = el
    this.menuButton = el.querySelector('[data-menu-button]')
    this.menuContent = el.querySelector('[data-menu-content]')
    this.menuItems = [...this.menuContent.querySelectorAll('a:not([disabled])')]
    this.hidden = true
    this.prevIndex = null
    this.currentIndex = 0

    this.menuButton.addEventListener('click', this.handleClick.bind(this))
    this.menuButton.addEventListener('keydown', this.handleKeydown.bind(this))
    this.menuItems.forEach(el =>
      el.addEventListener('keydown', this.handleMenuItems.bind(this))
    )

    resize(this.onResize.bind(this))
  }

  onResize() {
    if (window.innerWidth >= 1024) {
      if (this.menuContent.classList.contains('hidden')) {
        this.menuContent.classList.remove('hidden')
      }
    }
  }

  open() {
    if (this.menuContent.classList.contains('hidden')) {
      this.menuContent.classList.remove('hidden')
    }

    setTimeout(() => {
      document.body.classList.add('is-menu-visible')
    }, 10)

    this.menuItems[0].focus()
    this.hidden = false
  }

  close() {
    document.body.classList.remove('is-menu-visible')

    setTimeout(() => {
      this.menuContent.classList.add('hidden')
    }, 250)

    this.menuButton.focus()
    this.hidden = true
  }

  handleClick() {
    this.menuButton.setAttribute('aria-expanded', this.hidden)

    if (this.hidden) {
      this.open()
    } else {
      this.close()
    }
  }

  handleKeydown(e) {
    /* 'Down' arrow or 'space' key pressed */
    if (e.keyCode === 40 || e.keyCode === 32) {
      this.open()
    }
  }

  handleMenuItems(e) {
    /* 'Down' key pressed */
    if (e.keyCode === 40) {
      const nextIndex =
        this.currentIndex < this.menuItems.length - 1
          ? this.currentIndex + 1
          : 0
      this.menuItems[nextIndex].focus()
      this.currentIndex = nextIndex
    }

    /* 'Up' key pressed */
    if (e.keyCode === 38) {
      const nextIndex =
        this.currentIndex === 0
          ? this.menuItems.length - 1
          : this.currentIndex - 1
      this.menuItems[nextIndex].focus()
      this.currentIndex = nextIndex
    }

    /* 'Esc' or 'Tab' key pressed */
    if (e.keyCode === 27 || e.keyCode === 9) {
      this.close()
    }
  }
}

export default Menu
